import { useEffect, useState } from "react";
import HeaderNavBar from "../../../components/header-nav-bar";
import { useAuthGuard } from "../../../hooks/useAuthGuard";
import { useWorkService } from "../../../services/work.service";
import { Roles } from "../../../types/user.types";
import { useParams } from "react-router-dom";

export interface UnreleasedSheetsProps {}

export default function UnreleasedSheets(props: UnreleasedSheetsProps) {
  useAuthGuard(Roles.Admin);
  const { matterId } = useParams();
  const [sheetNumbersWithUnreleasedWork, setSheetNumbersWithUnreleasedWork] = useState<number[]>([]);

  const { getSheetsWithUnreleasedWork } = useWorkService();

  useEffect(() => {
    if (!matterId) {
      return;
    }
    getSheetsWithUnreleasedWork(matterId).then((sheetNumbers) => {
      setSheetNumbersWithUnreleasedWork(sheetNumbers);
    });
  }, [getSheetsWithUnreleasedWork, matterId]);

  return (
    <div className="container">
      <HeaderNavBar backTo="details" />
      <div className="row tablet-view justify-content-start">
        <div className="col-4 tablet-left d-flex flex-column">
          <div className="tablet-buffer d-flex flex-fill flex-column mb-2">
            <div className="mb-auto">
              <h2>Sheets with Unreleased Work</h2>
            </div>
          </div>
        </div>
        <div className="col-8 tablet-right">
          <div className="tablet-buffer">
            <table className="sw">
              <thead>
                <tr className="d-flex">
                  <th scope="col" className="col-sm-3">
                    Sheet Number
                  </th>
                  <th scope="col" className="col-sm-9">
                    Link to Sheet Release
                  </th>
                </tr>
              </thead>
              <tbody>
                {sheetNumbersWithUnreleasedWork?.map((sheetNumber) => (
                  <tr key={sheetNumber} className="d-flex border-bottom">
                    <td className="col-sm-3">{sheetNumber}</td>
                    <td className="col-sm-3">
                      <a
                        href={`/admin/matters/${matterId}/release/${sheetNumber}`}
                      >{`/admin/matters/${matterId}/release/${sheetNumber}`}</a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
